module.exports = __webpack_public_path__ + "assets/svg/Icons/32/position-gray-ed414a.svg";